const productSlider = {
    _sliderObject: null,

    //inicializace slideru 
    init() {

        if(!document.querySelector('.js-product-slider')) {
            return;
        }

        let self = this;

        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';

        window.initPackage(scriptUrl).then(() => {
            self._constructSlider();
        }).catch((error) => {
            console.error(error);
        });
    }, 


    //vytvoření jednotlivých sliderů
    _constructSlider() {
        let self = this;
                
        self._sliderObject = new Swiper('.js-product-slider', {
            direction: 'horizontal',
            effect: 'slide',
            spaceBetween: 24,
            slidesPerView: "auto",
            slidesPerGroupAuto: false,
            slidesPerGroup: 1,
            cssMode: true,
            centeredSlides: true,
            centeredSlidesBounds: true,
            breakpoints: {
                992: {
                    cssMode: false,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    slidesPerView: 3,
                },
                1200: {
                    cssMode: false,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                    slidesPerView: 4,
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    },


    reInit() {
        let self = this;

        if(self._sliderObject) {
            self._sliderObject.destroy();
            self._sliderObject = null;
        }

        self.init();
    },
}
productSlider.init();
document.addEventListener('LokiRequestEnd', function () {
    productSlider.reInit();
});